module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d7e523"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }, [_vm._v("One")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "c3"
    }
  }, [_c('h2', {
    staticClass: "chapttl",
    attrs: {
      "id": "d7e524"
    }
  }, [_vm._v("The First Month")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e526"
    }
  }, [_c('b', [_c('i', [_vm._v("C")])]), _vm._v("ongratulations, you did it! You got knocked up! I don't know about you, but the whole process of conception was quite a bit more than I had expected. I ignorantly thought that if you had unprotected sex, you'd conceive. I didn't know you needed the accuracy of a moon launch to make a sperm make contact with an egg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e530"
    }
  }, [_vm._v("To begin with, I was at the advanced age of thirty-five when I ventured down the path of procreation. This meant that my window of opportunity to conceive had shrunk from the size of a garage door to that of a peephole. If my husband and I stayed to watch the end credits of a movie, we could blow it until the next month.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e532"
    }
  }, [_vm._v("At first I tried the basal thermometer method. That's the one where you "), _c('i', [_vm._v("must")]), _vm._v(" take your temperature every morning before you get out of bed. (I can't tell you how many times I remembered that while I was sitting on the toilet each morning.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e537"
    }
  }, [_vm._v("Next, I looked into the vaginal discharge method. Although it's been used throughout the ages, I found the process of searching myself for “egg white” rather gross. So, I turned to medical science. I bought an ovulation predictor kit, peed on a stick, and had sex three nights in a row as instructed. A couple of weeks later I took a pregnancy test and saw the two lines that I had been praying for! I was pregnant! I was the happiest that I'd ever been. Little did I know that my pregnancy experience was at its peak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e539"
    }
  }, [_vm._v("For days, I was in a constant state of euphoria. I was looking forward to my turn as a proud mama-to-be. I was going to look like those beautiful pregnant women on book covers and glide through these next nine months with a soft focus lens and a constant smile. Sure, I was prepared to eat a cracker once in a while, and knew that there might be an ache or pain along the way, but how bad could it really be?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e541"
    }
  }, [_vm._v("But every month seemed to bring an unexpected bombardment of pregnancy ailments. And it seemed that as soon as one misery dissipated, another one took its place. I've jotted down the ailments that I had (and some others that I didn't but threw in for good measure), and when I experienced them. Your trip down your own road of gestation may be different than mine, filled with its own unique twists and turns. You may get some ailments earlier than I did, some later on, or I hope, not at all. But, in general, each month will bring on its own unique roadblock that you'll have to plow through. I'll explain each one to you in detail and offer my advice on how to ease the distress that going forth and multiplying can bring.")])]), _c('h3', {
    attrs: {
      "id": "d7e544"
    }
  }, [_c('a', {
    attrs: {
      "id": "c3"
    }
  }), _c('a', {
    attrs: {
      "id": "s1"
    }
  }, [_vm._v("Choosing an O.B.")])]), _c('a', {
    attrs: {
      "id": "s1"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e546"
    }
  }, [_vm._v("The first thing that you'll want to do after you pass your pregnancy test is look for an obstetrician. Not only do you want him (or her, but I'm going to use “him” since mine was a “him”) to confirm the results of your pregnancy test, you're going to want to start your prenatal care as soon as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e548"
    }
  }, [_vm._v("I put a lot of research into choosing my obstetrician. I asked for recommendations. I went over references. Then, after realizing how expensive it would be otherwise, I chose the doctor covered by my insurance plan. I was skeptical at first. I didn't know anything about him or anyone who went to him. But I figured I'd at least give him a try. If I didn't like him, we'd shell out the big bucks and later push our child into going to a community college.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e550"
    }
  }, [_vm._v("While waiting for my first visit, the background check began. I asked several of his other patients waiting with me, and they all raved about the doctor, saying that he was a wonderful man. A couple of the women were even going back to him for their second and third babies! Repeat customers, now that's high praise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e552"
    }
  }, [_vm._v("When I finally met my doctor I liked him right away. He was knowledgeable, personable, and had an air of confidence that made me feel like everything was going to be okay in his hands. And what a pair of hands they were. For some reason they were incredibly huge and puffy. Each finger was like a cooked Ball Park Frank. If anyone could safely catch my newborn as it fell from my uterus into the world, it would be him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e554"
    }
  }, [_vm._v("I hope you'll be fortunate enough to have a choice in picking an obstetrician. You may even be deciding between several of them. If that's the case, let me offer some suggestions on how to choose one. I'm assuming that they'll be board certified and have good references from friends or family. Also, that they have privileges at the hospital where you wish to deliver, and agree to any specific birth plan that you may have in mind. But, assuming all is equal, here are a few suggestions that may put one over the top and help you decide which one to pick:")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e556"
    }
  }, [_c('b', [_vm._v("1. Which doctor's office is closer?")]), _vm._v(" You'll be going to your doctor often. You'll probably have a checkup every four weeks for the first six months, then one every other week until the last month, when you will go every week. And in between your checkups you'll need blood workups and glucose tests and genetic evaluations, and so on. If you lease your car, a doctor who is far away could put you over your mileage limit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e560"
    }
  }, [_c('b', [_vm._v("2. Does he have an in-house ultrasound machine?")]), _vm._v(" My O.B. didn't have an ultrasound machine available at his office, but many do. Whenever I needed to have an ultrasound, I had to make another appointment somewhere else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e564"
    }
  }, [_c('b', [_vm._v("3. What's your O.B. 's vacation schedule?")]), _vm._v(" Obstetricians have a demanding life. They treat patients during office hours, and can also be up all night delivering babies. This hectic workload can make for a doctor who desperately needs a vacation. But you don't want his vacation to be anywhere near your due date.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e568"
    }
  }, [_c('b', [_vm._v("4. How far do some of his patients travel to see him!")]), _vm._v(" I know this doctor in Los Angeles who has patients from as far away as San Diego. You gotta think that if a patient is willing to drive up to two hours for an office visit, he must be damn good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e572"
    }
  }, [_c('b', [_vm._v("5. What is his list of acceptable medications!")]), _vm._v(" Not all O.B. 's agree when it comes to taking medications. Some dissuade you from taking any medications at all while others disperse them freely. My personal advice is to choose the doctor who allows for the most kinds of medications. You don't have to take them if you don't want to, but they're there if you do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e577"
    }
  }, [_c('b', [_vm._v("6. What magazines does he subscribe to!")]), _vm._v(" You'll no The First Month 5 doubt be spending a great deal of time in the waiting room. I would try to make my appointments either the first one of the day or the first after lunch so the wait would be less, but it didn't always help. I still had to wait. But my doctor had fantastic magazines that made the waiting time easier.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e581"
    }
  }, [_c('b', [_vm._v("7. Does he practice in a group or as an individual!")]), _vm._v(" If he's in a group, you may not be seeing him at every visit but rather may alternate with other partners in the group. Also, you'll want to find out if he'll be the one who delivers your baby instead of another doctor whom you may not be as comfortable with.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e585"
    }
  }, [_vm._v("As the months went on, I found myself developing a slight crush on my doctor. I hear this is pretty common. Maybe it's because your doctor will care about your unborn child as much as you will. Maybe it's because of all the support he'll give you during this emotional time. Or maybe it's because he takes the time to read all the pregnancy books that you can't get your own husband to look at. No matter the reason, don't be surprised if you put on your sexiest muumuu before each appointment.")])]), _c('h3', {
    attrs: {
      "id": "d7e588"
    }
  }, [_c('a', {
    attrs: {
      "id": "s1"
    }
  }), _c('a', {
    attrs: {
      "id": "s2"
    }
  }, [_vm._v("The No-No List")])]), _c('a', {
    attrs: {
      "id": "s2"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e590"
    }
  }, [_vm._v("I guess it's all a matter of give-and-take. Now that you've been given one of the greatest gifts of life, some of the greatest pleasures are going to be taken away. I knew about the biggies I'd have to abstain from once I conceived, but there were many more that I was unaware of. Here is a partial list of pregnancy no-no's you too should adhere to:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Alcohol")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Cigarettes")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Caffeine (Some doctors believe a small amount is okay.)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Excess chocolate (it has caffeine)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Heating pads turned on high")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Drugs (except those prescribed by your doctor)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Soft cheeses like goat and Brie (if you can cut it with a butter knife, you should probably steer clear)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Chemical hair dyes (most all doctors agree that vegetable dyes and hennas are best during pregnant)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Diet drinks (or anything that contains an artificial sweetener)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Hot showers (very hot temperatures can cause birth defects)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Hot tubs (same reason as hot showers)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Electric blankets (same reason as hot tubs and showers)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Microwaves (don't stand in front of them)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Changing the litter box (you could get toxoplasmosis)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Sushi (you could get parasites)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Aerobic class (during the first trimester if you're not used to them)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Bikini waxing (just for the first trimester because of the risk of an infected ingrown hair)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Air travel (during the last eight to ten weeks of pregnancy)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Insecticides")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("X-rays (unless essential and approved by your O.B.)")])]), _vm._v(" "), _c('li', {
    staticClass: "space"
  }, [_c('p', [_vm._v("Strong chemical fumes (oven cleaner, gasoline, etc.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e657"
    }
  }, [_vm._v("I say this is a partial list because by the time this book comes out they may have come up with another major no-no that's destined to cause your belly buddy some harm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e659"
    }
  }, [_vm._v("My mom never understood it when I passed up coffee at dinner or skipped the chocolate cake. She said that people are too educated these days. In her day she could eat or drink or smoke anything she wanted and everything turned out just fine. It was much better back then. I ranted and raved that in her day there were also many more underweight and premature babies, as well as babies with birth defects, immature lungs and even worse, babies who were stillborn. She didn't say anymore about it… ever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e661"
    }
  }, [_vm._v("It's very frustrating that there is so much you have to deny yourself when you're pregnant. It would be much easier to enjoy yourself in your condition if there were a different kind of list of no-no's to adhere to. I'd like to propose the following things that one must also abstain from when with child:")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e663"
    }
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Doing dishes")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e667"
    }
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Running errands")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e671"
    }
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Using a computer")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e675"
    }
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Pretreating laundry")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e679"
    }
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Killing household insects")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e684"
    }
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Driving people to the airport")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e688"
    }
  }, [_c('b', [_vm._v("7.")]), _vm._v(" Enduring bad hair days")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e692"
    }
  }, [_c('b', [_vm._v("8.")]), _vm._v(" Cleaning out a raw chicken")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e696"
    }
  }, [_c('b', [_vm._v("9.")]), _vm._v(" Waiting in line")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e700"
    }
  }, [_c('b', [_vm._v("10.")]), _vm._v(" Being on hold")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e704"
    }
  }, [_c('b', [_vm._v("11.")]), _vm._v(" Paying full price")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e708"
    }
  }, [_c('b', [_vm._v("12.")]), _vm._v(" Folding fitted sheets")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e712"
    }
  }, [_vm._v("If you're one of the “they” people — “they” say you have to do this, and “they” say you have to do that — I'd like for you to consider the above list. It would make enduring pregnancy so much more enjoyable. Thank you for your time.")])]), _c('h3', {
    attrs: {
      "id": "d7e715"
    }
  }, [_c('a', {
    attrs: {
      "id": "s2"
    }
  }), _c('a', {
    attrs: {
      "id": "s3"
    }
  }, [_vm._v("Sore Boobs")])]), _c('a', {
    attrs: {
      "id": "s3"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e717"
    }
  }, [_vm._v("One of the first symptoms of pregnancy that you'll no doubt experience will be sore breasts. Every pregnant woman I know had this symptom. It's just like the tender, achy feeling that you experienced when you had your periods, only super-sized.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e719"
    }
  }, [_vm._v("Having sore boobs can be quite frustrating for those desperately trying to conceive. You struggle to calculate your fertile time, wait those endless two weeks to see if you've hit the jackpot, then suddenly, as you near the end of your cycle, your boobs begin to ache. Are they sore because you're pregnant, or are they sore because they always are before your period?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e721"
    }
  }, [_vm._v("In general, most early pregnancy symptoms are the same ones as menstrual symptoms so it's difficult to tell which you're experiencing. Are you yelling because you're having a mood swing or is it just PMS? Are you late because you conceived, or because you're stressed out from trying? This is a cruel joke Mother Nature plays on her innocent little children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e723"
    }
  }, [_vm._v("I'm not sure why the boobs even need to get involved at this point of the pregnancy game. They don't really play into the whole baby picture until after the kid is born, and then it's suppertime! If you ask me, those glands are a little too ambitious, definitely a type A personality.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e725"
    }
  }, [_vm._v("You may find that the most frustrating thing of all about sore boobs is that it makes tummy sleeping quite difficult. I don't know about you, but for me there's no other position quite as comfy. But, with those swollen mammaries in the way, it's impossible to lie on your stomach without aches and pains. And to make matters even more infuriating, the breast tenderness starts to go away around the fourth month of pregnancy, which is the same time that your belly will get too big to sleep on!")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e727"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e728"
    }
  }, [_c('b', [_vm._v("“My breasts ached so bad that I went to the beach and dug a hole in the sand so I could lie down without pain. It felt too good, because I fell asleep and woke up three hours later with a sunburn that hurt far worse than my breasts ever did.“")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e731"
    }
  }, [_c('b', [_vm._v("— Julie")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e734"
    }
  }, [_vm._v("Just like premenstrual breast tenderness, there's not much to do about it. I only have a pittance of advice to give:")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e736"
    }
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Don't wear an underwire bra.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e740"
    }
  }, [_c('b', [_vm._v("2.")]), _vm._v(" If you must wear one, buy one that's one size bigger than you need. This way there's room for your breasts to roam free, and the wire that's there to lift and support won't smush and contort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e744"
    }
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Avoid standing in wind tunnels, or living in Chicago. A strong gust can really make those puppies ache.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e749"
    }
  }, [_vm._v("The pain in your breasts should ease by about the third or fourth month. And by that time they'll amaze you, if you were small breasted to begin with. For your tiny boobs will grow like giant water balloons. You'll finally have those large firm breasts that you've always dreamt of. But, if you were fairly large breasted to begin with like me, that dream will become a nightmare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e751"
    }
  }, [_vm._v("I was one of those girls who started developing early and I always felt uncomfortable with my ample size. Besides, my personality is more spunky than voluptuous. I'm like a breast-transsexual — a small-breasted personality trapped in a full-figured woman. So, when my pregnancy boobs started to grow in, I became scared of them. I looked at myself in the mirror and saw the chest of my bosomy Aunt Florence. I remember once as a child going to her house and seeing her change into a bathing suit. When I saw those overgrown protrusions staring down at me, I ran far and I ran fast. But now that they were on me, there was no place to run.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e753"
    }
  }, [_vm._v("I can't suggest anything that will deflate your pregnancy breasts, so get used to them. They come in quite handy to rest a dinner plate on when you're at a buffet. They'll also keep you safe from drowning. I do recommend that you treat these titties with care. From my own personal experience, I strongly suggest that you invest in a good support bra. I had good bras to begin with, but when my pregnancy boobs arrived, I knew I needed to bring in the heavy artillery. I bought several bras throughout my pregnancy to keep up with the expansion, and they all were well constructed. These things strapped my breasts in place like a house bolted to its foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e755"
    }
  }, [_vm._v("I also suggest that you wear your bra from the moment you conceive until the day you stop breastfeeding — morning, noon, "), _c('i', [_vm._v("and")]), _vm._v(" night. Not to brag, but my breasts don't look that much worse for the wear (not that they were all that great to begin with), and I really think it's because of all the support I gave those girls during those long and strenuous months.")])]), _c('h3', {
    attrs: {
      "id": "d7e761"
    }
  }, [_c('a', {
    attrs: {
      "id": "s3"
    }
  }), _c('a', {
    attrs: {
      "id": "s4"
    }
  }, [_vm._v("Morning, Noon, and Night Sickness")])]), _c('a', {
    attrs: {
      "id": "s4"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e763"
    }
  }, [_vm._v("I had been floating on a cloud for a week after I passed my pregnancy test. There was a smile on my face not even rush hour traffic could wipe away. But then, it happened. I was run over by a truck. Not an actual truck, mind you, but it felt as if it had been. It hit me without warning and it hit me hard. I was struck with morning sickness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e765"
    }
  }, [_vm._v("I know that for some incredibly lucky people, probably the same ones who can eat anything they want without getting fat, morning sickness doesn't strike at all. Or at the least, it can be cured by eating a cracker. For me, it was so powerful, that, at times, it made me wish that I'd never gotten pregnant. I know that sounds harsh, but being pregnant can induce a state of temporary insanity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e767"
    }
  }, [_vm._v("Morning sickness is like waking up every day for three months with a terrible flu. It usually begins in the fifth or sixth week of pregnancy and lingers until about the fourteenth. It doesn't creep up on you but comes on with a vengeance. It drains you of your spirit and takes away your ability to care about anything. The fridge is broken? Who cares, you're nauseated. The dog's fur just fell off? Not your problem. You're weak. I can't believe that some mothers-to-be have to endure this kind of misery. Morning sickness gave me a whole new respect for womankind, and made me swear that I'd never raise my voice to my mother again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e769"
    }
  }, [_vm._v("Whoever named it morning sickness was terribly mistaken. The name implies that you only feel bad when the day begins. It gives you false hope that, as the day goes on, you'll start to feel better. But then you don't. At least I didn't. I suffered the entire day. I suggest that the name be changed to “morning-noon-and-night sickness.” Truth be told, there was one point in each day that I wasn't in misery. For ten beautiful minutes each morning before I got out of bed, I felt no pain. I would lie there and remember what it felt like to be a human being.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e771"
    }
  }, [_vm._v("No one knows the cause of morning sickness. One theory I heard is that morning sickness is the result of your body trying to rid itself of the infection you call your baby. It sees your offspring as a foreign matter that must be destroyed. Another theory is that morning sickness is caused by the increased level of progesterone in your system that keeps the baby alive. In fact, if you have severe morning sickness, the old wives say that you'll have a girl. You'll find that these wives have a lot to say during your pregnancy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e773"
    }
  }, [_vm._v("But even if no one can agree on the cause, they all agree on one thing. There is no cure. Believe me, if there were, I would have found it. I searched high and low. I asked doctors and surfed the Internet. I couldn't believe there was no pill to cure my ill. It's barbaric. There should be a team of researchers working around the clock. There should be a clinic in every city across the nation devoted to find a cure. There should be a yearly telethon with a poster child of a green bloated woman clutching hard on to a toilet bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e775"
    }
  }, [_vm._v("Unlike any other illness, don't expect morning sickness to get you a lot of sympathy — except from other women who have gone through it themselves. Your friends and family will be too excited that you're pregnant to really pity you the way you deserve. I remember lying facedown on my office floor, and whenever someone came in, they would just look at me and smile. There was no “Can I get you anything?” or “Why don't you go home?” There was just a damn smile. Maybe if morning sickness came with the physical symptoms it deserves — like convulsions or dismemberment — it would get the proper recognition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e777"
    }
  }, [_vm._v("So, let's get down to the burning question: What can you do to feel better? When I had morning sickness, I asked every pregnant woman I saw if she had any advice. I'd stop them in the produce section. I'd corner them in elevators. I'd hope beyond hope that they would utter some words of wisdom that would get me through this terrible time. I found many of these women to be very knowledgeable. I got several different suggestions, which I'll pass along to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e779"
    }
  }, [_c('b', [_vm._v("I. Sea bands.")]), _vm._v(" They're soft wristbands you can get at a drug store that you wear tightly on each wrist. They were originally created to ease the nausea caused by motion sickness. They have a hard plastic ball on the inside of them that presses against your wrist. This is a pressure point in acupuncture that helps with nausea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e783"
    }
  }, [_c('b', [_vm._v("2. Lemon wedges.")]), _vm._v(" The theory behind this is that if you're nauseated, take a bite of a slice of lemon. Your brain can't react to both the nausea and the bitter taste of the lemon at the same time, and since the taste of the lemon is stronger, it wins out. You may feel as though you've eroded the enamel off your teeth, but at least you won't feel sick.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e788"
    }
  }, [_c('b', [_vm._v("3. Ginger.")]), _vm._v(" Supposedly, it's a natural nausea reliever. You can try crystallized ginger, ginger tea, or better yet, just gnaw on a chunk of raw ginger root.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e792"
    }
  }, [_c('b', [_vm._v("4. Eat protein with carbohydrates.")]), _vm._v(" Many women told me that they felt much better after eating cheese and crackers, a tuna fish sandwich (if you can tolerate the smell), or any combination of protein and carbohydrates together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e796"
    }
  }, [_c('b', [_vm._v("5. Black licorice.")]), _vm._v(" I met a woman at a barbecue who swore by black licorice. I ate several pieces, but the only thing it helped me cure was my sweet tooth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e800"
    }
  }, [_c('b', [_vm._v("6. Raspberry tea.")]), _vm._v(" Dafna, my friend who is a midwife, told me about this. I always gave it more clout because of that. Although it didn't cure my morning sickness, I rather liked the taste and still drink it to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e804"
    }
  }, [_vm._v("I gave all of these suggestions a try and, although some may have eased the distress somewhat, nothing took it away completely. So, I turned to my doctor. Luckily, he was a firm believer in over-the-counter medication. My doctor's remedies did help to soften the green around my gills, so I'll tell you what he said. Be sure to ask your doctor if these medicines are okay, and if they are, ask him what dosage you need to take. It may be different than the dosage on the package. He may also have some other tricks up his sleeve, and if he does, I suggest that you try them all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e806"
    }
  }, [_c('b', [_vm._v("1. Benadryl.")]), _vm._v(" It's an antihistamine that will make you drowsy. Not only will this calm you down, but it might also calm down your tummy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e810"
    }
  }, [_c('b', [_vm._v("2. Emetrol.")]), _vm._v(" It's like cola without the bubbles and is specifically marketed to help relieve nausea. You can buy this over the counter at most drug stores.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e814"
    }
  }, [_c('b', [_vm._v("3. Dramamine.")]), _vm._v(" This is medicine used to alleviate sea sickness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e818"
    }
  }, [_c('b', [_vm._v("4. Vitamin B6.")]), _vm._v(" If you are having trouble keeping your prenatal vitamins down, your doctor might prescribe some that have extra vitamin B6 as this has been proved to quell that queasiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e822"
    }
  }, [_c('b', [_vm._v("5. Unisom.")]), _vm._v(" Yes, I know it's marketed as a sleep aid, and indeed it may make you drowsy, but it may also make you feel better. If your doctor allows, take half a tablet with 50 milligrams B6.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e826"
    }
  }, [_vm._v("I came up with a few suggestions of my own, too. First of all, take caution when it comes to your prenatal vitamin. Those pills are so strong they can cause nausea all by themselves. Don't take it all at one time. I suggest half in the morning and half at night. If that's still too strong, break it into thirds, or fourths, or twelfths — or just put it on a stick and lick it throughout the day. During the worst of my morning sickness, I skipped my prenatal altogether, and took my everyday vitamin. Yes, I told my doctor first. I know you're thinking I'm a horrible mother depriving my helpless embryo of its nourishment, but how much riboflavin does a ten-cell organism need? Besides, my doctor told me that the embryo took all the nutrients it needed from me, so those pills were actually to keep "), _c('i', [_vm._v("me")]), _vm._v(" healthy. I don't know about you, but I survived an entire college semester on Doritos and cookie dough. I was going to be just fine. If you find that your prenatal vitamins are making your stomach uneasy, ask your doctor if you can skip them as well. As long as you take a one-milligram tablet of folic acid daily, he may not have a problem with it. You can also try switching the brand of your prenatal vitamin. Not all prenatal vitamins are created equal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e832"
    }
  }, [_vm._v("Also, NEVER take your prenatal vitamin on an empty stomach. It will make you sick so fast your head will spin (or at least it'll spin after you've puked). It's important always to keep something in your stomach, anyway. You should put some crackers by your bed and have a couple before you even get up in the morning. I know you don't feel the least bit hungry, but do it. I ate a bunch of little meals throughout the day. About forty-five to be truthful. Don't force yourself to eat something that might make you sick, but find something you can tolerate and stick with it. Comfort foods usually work well. I found myself drinking a lot of Slurpees, something I hadn't had since I owned a “Close and Play.“")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e834"
    }
  }, [_vm._v("Also, be extra careful brushing your back teeth. I don't know why it happens, but all of a sudden putting a toothbrush in the back of your mouth is going to make you throw up. I suspect that there's some type of gag reflex that starts up in the first stages of pregnancy. You can be feeling perfectly fine and then, out of nowhere, BLECH! So just focus on the front teeth and avoid talking throughout the day. This shouldn't be much of a problem since your sallow complexion will be a tip-off to those around you that you're not in the mood for stimulating conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e836"
    }
  }, [_vm._v("I hope that these suggestions will make you feel better. But even if they don't, keep in mind things could be worse. You could have been born an elephant. Their gestation period is about two and a half times as long as ours, which means that they spend about eight months in morning sickness misery. In my lowest moments, I found this to be a comfort.")])]), _c('h3', {
    attrs: {
      "id": "d7e840"
    }
  }, [_c('a', {
    attrs: {
      "id": "s4"
    }
  }), _c('a', {
    attrs: {
      "id": "s5"
    }
  }, [_vm._v("Gas!")])]), _c('a', {
    attrs: {
      "id": "s5"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e842"
    }
  }, [_vm._v("From almost the moment you conceive, your body does an amazing thing. Your digestive system slows down, allowing it time to squeeze out every nutrient it can from your food. This process, albeit a miraculous design of nature, makes you toot. They say there's a glow about a pregnant woman. The glow is undoubtedly the stress she's enduring trying not to cut one right in front of you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e844"
    }
  }, [_vm._v("You can try eliminating certain foods from your diet such as cabbage or beans. I didn't find that this made much of a difference. Even ice water played havoc on my innards. You can try eating small meals, avoiding tight waistbands, and sleeping with your head elevated. You can try strapping a monkey on your butt for all the good that'll do either. Or you can try taking some of my advice, such as the following.")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e846"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e847"
    }
  }, [_c('b', [_vm._v("“Once, after a long meeting, I went to my office and let out the gas I'd been holding in for so long, just then, the whole staff came in to surprise me with a 'congratulations on being pregnant' cake. I think they were as surprised as I was.“")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e850"
    }
  }, [_c('b', [_vm._v("— Lisa")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e853"
    }
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Request your own office.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e857"
    }
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Learn to say “Excuse me” in several different languages. This won't cure the gas, but you'll be improving your mind, which is always a good thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e861"
    }
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Practice squishing up your nose in disgust and looking around for the guilty party.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e865"
    }
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Suggest that your husband sleep on the couch. He'll no doubt be grateful for the permission.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e869"
    }
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Keep a window open at all times. Otherwise, you're not going to be able to stand being in the same room with yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e873"
    }
  }, [_vm._v("This kind of intestinal disturbance may have another side effect on you as well. It's an unusually hearty and consistent burp. It's not a burp exactly, more like a burp crossed with a hiccup. It's much louder than a burp and, like hiccups, comes on without any notice. And come on it does.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e875"
    }
  }, [_vm._v("I would bur-cup so often it became second nature. After a while, I wasn't even aware of what I was doing. I would bur-cup in restaurants. Bur-cup in movie theaters. Bur-cup in meetings. Bur-cuping became as natural to me as breathing. It drove my husband insane. Once in a while he'd flash me a look like, “Can't you stop those stupid things already?” and I'd flash one right back that said, “Don't you dare criticize me when I'm feeling so miserable and you walk around everyday without vomiting or suffering any ill side effects at all from carrying around our child.” Which brings me to another topic…")])]), _c('h3', {
    attrs: {
      "id": "d7e878"
    }
  }, [_c('a', {
    attrs: {
      "id": "s5"
    }
  }), _c('a', {
    attrs: {
      "id": "s6"
    }
  }, [_vm._v("Resentment Toward Your Hubby")])]), _c('a', {
    attrs: {
      "id": "s6"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e880"
    }
  }, [_vm._v("First of all, let me explain one thing. Whenever I refer to that special someone in your life, I'm going to call it “your husband.” In your case, it may very well be a husband, but it might also be a boyfriend, a partner, a girlfriend, a lover, a dear friend, or maybe even a ferret. I don't know and I don't care. But, for simplicity sake, I'll just stick with “husband.” Not only will it save me from doing a lot of extra typing (husband/boyfriend/girlfriend, etc.), but it will also be less confusing to the five remaining brain cells I have left after having a child (we'll get to that part later). So, with that understood, let us continue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e882"
    }
  }, [_vm._v("It's hard not to resent your husband when you're feeling like you're re-enacting the pea soup scene from "), _c('i', [_vm._v("The Exorcist,")]), _vm._v(" and he's walking around feeling “la-de-da” all day. I know it's irrational, but you may start to hate him. Okay, maybe “hate” is too strong a word. Let's just say that you'll loathe every cell in his body. It really is grossly unfair that the baby belongs to both of you, but the misery is yours and yours alone. And there's nothing, not one little thing that you can do to change that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e887"
    }
  }, [_vm._v("The only time my husband ever had any physical difficulty during the entire nine months of our pregnancy experience was during the third night of trying to conceive. He wasn't in the mood so he had to work at it, the poor dear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e889"
    }
  }, [_vm._v("But my husband is a good guy and did his best to try to help. Every day he would ask me what he could do for me, and every day I would answer the same way, “There's nothing, dear.” But it didn't take long for my sickness to grow and my patience to fade, and my standard answer changed to, “You could carry the damn thing for just one day, you selfish bastard.“")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e891"
    }
  }, [_vm._v("There are a couple of things you can do to lessen the resentment that you feel toward your spouse. First of all, insist that he do more things around the house. This won't lessen your resentment about carrying the child, but it will lessen your resentment about carrying the brunt of the household chores. If his constant pile of dirty socks is still at his bedside, ask him to put them away, or better yet, to do a load of whites. If you've always wanted shelves in the bathroom, now's the time to ask him to build them. Me, I wanted a new floor in the bathroom. Sure, tile work is hard but so is growing a child in your uterus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e893"
    }
  }, [_vm._v("Another way to relieve some of your resentment is to insist that your husband abstain from all the things that you must abstain from. No drink at the end of the day, or coffee after dinner and so on and so on and so on. You can even give him one of your prenatal vitamins (which he should take on an empty stomach) so he can experience the nausea along with you. What a bond you two will share! Not only will you feel less resentment toward him, but he'll also feel more compassion toward you. He'll put you up higher on your pedestal, which is exactly where a woman in your condition belongs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e895"
    }
  }, [_vm._v("I asked my husband to do this and he managed to give up most no-no's without any trouble. But the one no-no that he couldn't give up was smoking. He'd try to stop, but he just couldn't do it. After the baby was born, I insisted he quit. Not only did I love him and want him around for a long time, but, once I saw how hard childrearing was, I knew I didn't want to go at it alone. He tried patches and gum, and I tried yelling and guilt. But the thing that finally motivated him to stop was when I told him that I was going to start dating again. I figured that it could easily take a couple of years to find my next husband (a girl should be picky you know) and I didn't want to have such a lull in my matrimonial state. So he quit cold turkey. Imagine that.")])]), _c('h3', {
    attrs: {
      "id": "d7e898"
    }
  }, [_c('a', {
    attrs: {
      "id": "s6"
    }
  }), _c('a', {
    attrs: {
      "id": "s7"
    }
  }, [_vm._v("Tests, Tests, and More Tests")])]), _c('a', {
    attrs: {
      "id": "s7"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e900"
    }
  }, [_vm._v("Get out your number-two pencils ladies, there's going to be a test. Actually, there are going to be quite a lot of them. The entrance exam is already over. That was the pregnancy test, and I'm assuming that you aced it or you wouldn't be reading this book. But there's a college course load still to be done, so let's start cracking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e902"
    }
  }, [_vm._v("The first series of tests will take place during your first doctor's visit. On your first appointment, you'll be drained of some of your bodily fluids like pee, blood, and cervical juice (a pap smear). From these fluids, your doctor will test you for German measles, hepatitis B, and chicken pox. You'll also be given a CBC, and STS, and tested for HIV and STDs. But don't fear, it'll all be done PDQ (pretty darn quick) and you should be A-OK (I'll let you figure that one out for yourself). Your pee will be examined for bacteria, sugar, and albumin. Your blood pressure will be tested and charted. Some of these tests will be repeated during every doctor's visit throughout your pregnancy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e904"
    }
  }, [_vm._v("Assuming you pass the first round of tests, you can start cramming for your glucose screen. You don't want to fail that one or you'll have to take a three-hour glucose tolerance exam that's a killer. There's also a vaginal and rectal test for Group B streptococcus. And don't forget your triple screen blood test at about sixteen weeks. This will test for increased risk for Down syndrome and spinal cord abnormalities. There may be also be a test for Tay-Sachs, sickle cell, or any number of other genetic conditions. And, for extra credit, there's the optional CVS or amniocentesis.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e906"
    }
  }, [_vm._v("And finally, on graduation day, after you've delivered your thesis (a.k.a. your child), you will be awarded an important document worthy of framing. This piece of paper will be your baby's birth certificate, showing that you've passed all tests necessary to hold the position of “Parent.” You'll serve in that position for your entire life and work long grueling hours with no overtime, pension, or even a decent health plan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e908"
    }
  }, [_vm._v("After your baby is born, the tests will continue. In fact, there will be years' worth of tests that you'll have to endure. But this time the tests won't be given by a medical professional; they'll be given by your own child who will forever be testing your patience and limitations. So, good luck out there. Study well and "), _c('i', [_vm._v("E Pluribus Unum.")])])]), _c('h3', {
    attrs: {
      "id": "d7e913"
    }
  }, [_c('a', {
    attrs: {
      "id": "s7"
    }
  }), _c('a', {
    attrs: {
      "id": "s8"
    }
  }, [_vm._v("Dreams and Other Nightmares")])]), _c('a', {
    attrs: {
      "id": "s8"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e915"
    }
  }, [_vm._v("Being pregnant is an emotional time, and like any other mental anguish, it's going to show up in your dreams. I'm not talking about beautiful dreams like running through a meadow holding your halo-headed newborn. I'm talking about weird, freakish, and often disturbing dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e917"
    }
  }, [_vm._v("At the early stages of my pregnancy, most of my dreams centered on me causing my child extreme harm. I would dream that I left it at a mall. Or that I would forget to feed it for days at a time. I once dreamed that I was at the beach during the hottest day of the year, and I suddenly remembered that I had left my child locked in the trunk of the car. Panicked, I rushed to the parking lot and opened the trunk. I found my tiny loved one shriveled up like one of the pod people in "), _c('i', [_vm._v("Cocoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e921"
    }
  }, [_vm._v("About halfway though my pregnancy, my dreams started to change. Instead of centering around my being the worst mother in the world, they were about how deformed my newborn was. By far the most disturbing dream I had was the one where my child was born without any skin. I wasn't so much disturbed by her lack of skin as I was terrified of telling my husband about it. I remember holding my slimy little infant fearing that my husband would come into the room and get really mad at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e923"
    }
  }, [_vm._v("In another dream, I was trying to breastfeed my baby, but it was having trouble latching on. I looked down only to find that my child was born with a beak. I had several other dreams where my child was deformed. Once it had a severe wandering eye. Another time it had a face full of hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e925"
    }
  }, [_vm._v("I'm no psychiatrist, but it's not hard to figure out that being pregnant is incredibly scary. You may appear calm and steady during the daytime, but at night, your fear, along with your imaginary child, will rear its ugly head. But don't worry. These are only dreams, not premonitions. Despite all of my nighttime horror shows, my child was born without a beak or extra facial hair. So when you experience one of your nightmares, just relax and enjoy the show.")])]), _c('h3', {
    attrs: {
      "id": "d7e928"
    }
  }, [_c('a', {
    attrs: {
      "id": "s8"
    }
  }), _c('a', {
    attrs: {
      "id": "s9"
    }
  }, [_vm._v("To Tell or Not to Tell")])]), _c('a', {
    attrs: {
      "id": "s9"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e930"
    }
  }, [_vm._v("Now that you're pregnant, you want to shout it out to the world! It's by far the most exciting news that you've ever had! You can't wait to tell your friends, your family, and every member of your high school graduation class. I understand completely. I too was excited, and couldn't wait to share the news. But as you know, people advise you to wait until the second trimester before you start telling people, because the risk of miscarriage decreases significantly at that time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e932"
    }
  }, [_vm._v("Although I knew in my head that telling someone I was pregnant was not going to make my embryo dislodge from my womb, why take a chance? We agreed to hold off blabbing about it for a while. But that wasn't as easy as I expected. Whenever a friend asked me what was new, I bit my tongue. Soon, my tongue had so many holes I could drain spaghetti with it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e934"
    }
  }, [_vm._v("I felt as if I were going to burst with excitement. I was like an over inflated tire. If I didn't spill the beans soon and alleviate some of the pressure, I was going to pop. So, for the sake of highway safety I decided to tell someone. I decided that a relative stranger would be the perfect someone. Telling a stranger the good news would be like that five-second rule about eating dropped food — it doesn't really count.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e936"
    }
  }, [_vm._v("Soon after my decision, I saw my eighty-five-year-old neighbor, Grace, walk past my house. Grace would be perfect. She's not a friend or a family member; she's just someone who lives in my neighborhood. Grace has hip trouble so once a day she takes a slow walk around the block. And man, do I mean slow. By the time she gets home, it's almost time for her to go around again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e938"
    }
  }, [_vm._v("When she walked past me this time, she greeted me with her usual remark, “Hi, dear, what's new?” And finally, I spilled the beans! I told her about being pregnant and how excited I was. I babbled on and on about what my husband did when I told him and how sick I was feeling. It was so good to finally share the news! Grace looked at me, smiled and said, “Is that a new blouse, dear?” I realized then that Grace may have some hearing trouble as well, but I didn't care. I finally told someone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e940"
    }
  }, [_vm._v("After Grace, I was able to keep quiet for some time, but found that it was really hard to keep news (and a belly) of that size hidden. In addition to a thickening waistline, there were several other signs that got people suspicious. But, like any good pregnant woman in her first trimester, I lied. If I yawned a great deal, I told people I had stayed up for Letterman. Passing on wine meant I had too much to drink the night before. If I declined coffee at the office, I told coworkers I had a pot's worth at home. Nausea at a family dinner meant I had Indian food for lunch, and my comically large breasts meant I was about to get my period. I realized that I was an incredibly good liar and fabricated tales as only the Brothers Grimm could do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e942"
    }
  }, [_vm._v("Now, I'm not suggesting that you keep your mouth shut during this exciting time. It's a very personal decision. You may be too superstitious to consider tempting fate with the news. Or you may be too much of a blabbermouth to conceal it. But, whether you do or don't decide to start sharing the good news, I have some words of pregnancy wisdom to share with you (see, I told you I had a hard time keeping my mouth shut):")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e944"
    }
  }, [_c('b', [_vm._v("1.")]), _vm._v(" If you do decide to tell people, be picky. I feel that you should tell only the close friends and relatives you would turn to for comfort in difficult times. In case you do suffer a miscarriage, you'll no doubt tell them anyway because you'll need their shoulders to cry on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e948"
    }
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Have a list of premade excuses about why you're abstaining from alcohol, cigarettes, and coffee, and while you're at it, include one for why you can't stop yawning all day. You may find that you're not as talented a liar as I am, and it may be hard to come up with excuses on the spot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e952"
    }
  }, [_c('b', [_vm._v("3.")]), _vm._v(" If you feel as if you're going to burst with excitement as I did and you have to tell just one person, I suggest that you tell your boss (if you feel comfortable enough). Your work may slack off for a while, and you'll want to protect yourself. You may be preoccupied, moody, tired, and nauseated. You'll be on the phone making doctor's appointments and will surf the Internet for pregnancy info. You'll be so elated with the miracle growing in your belly that such a mundane thing as earning a living may lose its importance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e957"
    }
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Tell any and all pregnant women. You'll be amazed at what saying “I'm pregnant too” will do. Instantly, the bond will form. You'll share your fears, your excitement, your advice, and of course, your belly size (this will soon become as big a comparison issue as men in locker rooms). You'll find other “preggos” an amazing source of some much-needed support.")])]), _c('h3', {
    attrs: {
      "id": "d7e962"
    }
  }, [_c('a', {
    attrs: {
      "id": "s9"
    }
  }), _c('a', {
    attrs: {
      "id": "s10"
    }
  }, [_vm._v("Pregnancy Math")])]), _c('a', {
    attrs: {
      "id": "s10"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e964"
    }
  }, [_vm._v("Remember your old math classes in school? You memorized formulas, studied graphs, and figured out equations like how fast train A would pass train B if it were the third Tuesday of the month in a leap year. You'd put your head in your hand in frustration and ponder the age-old question: “When will I ever use this stuff?” Well, it turns out that the time has finally come.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e966"
    }
  }, [_vm._v("From the moment you conceive, you're going to need basic math skills. You'll either be trying to calculate how far along you are, or to figure out your due date. To the naive, you conceive a child and give birth nine months later. But to the educated, it's not that simple. In fact, figuring out basic pregnancy equations can be more complicated than figuring out the train one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e968"
    }
  }, [_vm._v("For pregnancy doesn't start the moment the sperm penetrates the egg like your mom told you during that uncomfortable “birds and bees” talk. Miraculously, you become pregnant on the first day of your last period. At least that's the case from an O.B.'s point of view. The theory is based on the fact that no woman is quite sure of the day that she ovulated (unless of course she was as neurotic as me and used an ovulation predictor kit), but she usually remembers when she began her last period. So, the nine-month countdown begins on that date. It's like getting extra pregnancy weeks for free. It's sort of the baker's dozen of gestation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e970"
    }
  }, [_vm._v("Now, since a full-term pregnancy lasts for forty weeks, you're actually two weeks pregnant when you conceive, and about a month along when you're finally aware that you're pregnant. Pretty cool, huh?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e972"
    }
  }, [_vm._v("Some women like to base their gestation on ten four-week intervals. It makes calculating much easier, but it changes the standard nine-month gestation into ten, and that's already too confusing. I won't discuss that theory any further without at least a prerequisite knowledge of logarithms. Luckily, the vast majority of preggies go by the nine-month, forty-week standard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e974"
    }
  }, [_vm._v("Now, it's time for the pop quiz: How many months pregnant would you be if you were entering your third trimester? Well, let's see… it seems simple enough. Each trimester is three months long, so you'd be starting your seventh month. Right? Wrong! All trimesters are not considered equal. The first trimester is the longest with fourteen weeks, and the second trimester is only twelve. So, if you were entering your third trimester you'd be twenty-six weeks pregnant and since there are 4.3 weeks in the average month, you'd be how many months pregnant?! Who knows? Who cares? The whole thing is too confusing. So, I have an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e976"
    }
  }, [_vm._v("I suggest that all you keep track of is how many weeks pregnant you are and keep it at that. Don't worry about months. Not only does this make the countdown to delivery simple (forty weeks minus “X” weeks pregnant equals delivery), but it forces others to do the math for you. When someone stops you in the checkout line and asks you how far along you are, tell them that you're twenty-three weeks. Then the fun starts as their eyes glaze over in frustration trying to calculate twenty-three weeks into months.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e978"
    }
  }, [_vm._v("Not only is my “weeks” theory more convenient, but it's good practice for when the baby finally comes out. You'll notice that a baby is never a month-and-a-half old, it's always six weeks. Never a year-and-a-half, but rather eighteen months. Not until your tot is two years old do you revert back to the rest of the world's twelve-month calendar year.")])]), _c('h3', {
    attrs: {
      "id": "d7e981"
    }
  }, [_c('a', {
    attrs: {
      "id": "s10"
    }
  }), _c('a', {
    attrs: {
      "id": "s11"
    }
  }, [_vm._v("How to Eat for Two")])]), _c('a', {
    attrs: {
      "id": "s11"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e983"
    }
  }, [_vm._v("No, this is not a segment about nutrition. I don't know the first thing about beta-carotines or triglycerides. The most scientific sounding food I ingest is Haagen-Dazs. But I do know a thing or two about the dynamics of pregnancy eating.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e985"
    }
  }, [_vm._v("The first dynamic is what I call the “I Have to Eat Now!” syndrome. I know you've experienced the hunger sensation before you conceived. Your tummy would growl and you'd be a little lightheaded. But you don't know hunger till you've experienced pregnancy hunger. All of a sudden you turn into the “Feed Me” plant from "), _c('i', [_vm._v("Little Shop of Horrors.")]), _vm._v(" Your body is burning a lot of calories to make this baby, and your metabolism is changing. Because of this, your blood sugar will drop like the price of tech stocks during the crash.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e990"
    }
  }, [_vm._v("When you experience one of these blood sugar drops, you'll need to eat and you'll need to eat fast! You'll invade your kitchen like locust on corn. Anything will do. Raw hot dogs, frozen peas, even powdered cake mix. Soon, your blood sugar will stabilize and you can rest. You'll catch a glimpse of your reflection in the toaster and see the face of a crazed animal after devouring a zebra carcass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e992"
    }
  }, [_vm._v("There are a few things to do to avoid this scene from a "), _c('i', [_vm._v("National Geographic")]), _vm._v(" special:")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e997"
    }
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Try not to have an empty stomach. Eat a lot of little meals throughout the day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1001"
    }
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Keep healthy snacks available — a bag of trail mix in your purse, some peanut butter crackers in your office drawer, and so forth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1005"
    }
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Eat protein instead of sugar. Protein takes longer to digest and fills your stomach for a longer period.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1009"
    }
  }, [_vm._v("The second dynamic of pregnancy eating is cravings. Suddenly, you'll have a strong desire for a certain kind of food. It may be one of your favorite foods or one that's grossed you out in the past. It's all a crap shoot. Not all pregnant women suffer with cravings to the same degree, but almost every one of them will experience some type of noshing urge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1011"
    }
  }, [_vm._v("Personally, I never had the kind of intense cravings that I saw on TV. I wished that I would have. Nothing would have pleased me more than to send my husband out during a blizzard to fetch me some turkey jerky. But my cravings were never that strong and besides, we live in Southern California. Still, it would have been the "), _c('i', [_vm._v("least")]), _vm._v(" he could have done, considering my condition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1016"
    }
  }, [_vm._v("As with almost everything else in the world of pregnancy ailments, cravings are caused by hormones, which should stabilize around the third or fourth month. And as your hormones stabilize, so will your cravings. You'll still have them, but they won't be as intense.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1019"
    }
  }, [_vm._v("Believe it or not, cravings actually serve a purpose. When you get an urge for a particular kind of food, it means that your body needs it for some purpose. You may be nutritionally depleted in some area or need something to help with nausea, and cravings let you know about it. I found that most of my cravings revolved around protein. I found myself eating loads of meat, chicken, and milk shakes (they have protein, don't they?). It seems that every day your baby takes vitamins and minerals from you that it needs to survive. Yes, that embryo that you adore is basically a tick sucking away your life force. So go ahead and eat. If you have a hankering for some kind of food, and it's not going to harm your precious parasite, by all means, scarf it down.")])])]), _c('a', {
    attrs: {
      "id": "s11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237cccc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kime_9781440501951_epub_c3.vue
// module id = 81
// module chunks = 0